import { Outlet, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { MyTrainingMaterialsDocument } from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { FileItem, FilesList } from 'modules/trainings/components/Files/FilesList/FilesList'

export default function MyTrainingsMaterialsPage() {
  const { navigation } = useNavigation()
  const { trainingId } = useParams<{ trainingId: string }>()
  const source = useGraphqlDataSource({
    document: MyTrainingMaterialsDocument,
    search: {
      enabled: true,
    },
    mapData: (data): FileItem[] => {
      const trainingFiles = data.trainings.trainingFilesConnection.nodes.map((file) => ({
        id: file.id,
        title: file.title ?? file.filename,
        contentType: file.contentType,
        filename: file.filename,
        size: file.size,
        type: 'training' as const,
        url: file.url,
      }))
      const trainingClassFiles = data.trainings.trainingClassFilesConnection.nodes.map((file) => ({
        id: file.id,
        title: file.title ?? file.filename,
        contentType: file.contentType,
        filename: file.filename,
        size: file.size,
        type: 'trainingClass' as const,
      }))
      return [...trainingFiles, ...trainingClassFiles]
    },
    mapVariables: ({ search }) => ({
      trainingId: Number(trainingId),
      search: search,
    }),
    mapPagination: (data) => {
      const trainingFiles = data.trainings.trainingFilesConnection.totalCount ?? 0
      const trainingClassFiles = data.trainings.trainingClassFilesConnection.totalCount ?? 0
      return {
        total: trainingFiles + trainingClassFiles,
      }
    },
    itemUrl: (item) => {
      return navigation.myTrainings.revamp.detailsRevamp.view.materials.file.fullPath({
        trainingId: Number(trainingId),
        fileId: item.id,
        fileType: item.type,
      })
    },
  })

  return (
    <Box gap="s16">
      <SectionHeader
        title={i18n.t(
          'trainings.my_trainings_revamp.training_detail.materials.section_header.title'
        )}
        description={i18n.t(
          'trainings.my_trainings_revamp.training_detail.materials.section_header.description'
        )}
        separator="bottom"
      />
      <FilesList
        source={source}
        emptyStates={{
          'no-data': {
            title: i18n.t(
              'trainings.my_trainings_revamp.training_detail.materials.datacollection.empty_state.no_data.title'
            ),
            description: i18n.t(
              'trainings.my_trainings_revamp.training_detail.materials.datacollection.empty_state.no_data.description'
            ),
          },
        }}
      />
      <Outlet />
    </Box>
  )
}
